import {apiSlice} from './apiSlice';

/**
 * Gói & Hạn mức của chính user (features/Subscription).
 *
 * - getMySubscription: gói hiện tại + thanh tiến trình (token/tháng, URL/tuần, dự án).
 *   Gắn tag 'Subscription' để tự refetch sau khi bị 402 hoặc khi admin đổi gói.
 * - getPlans: danh sách gói đang mở bán (bảng so sánh + nâng cấp).
 */
export const subscriptionApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getMySubscription: builder.query({
			query: () => ({url: 'subscription/me', method: 'get'}),
			transformResponse: (body) => body?.data || null,
			providesTags: ['Subscription'],
		}),
		getPlans: builder.query({
			query: () => ({url: 'subscription/plans', method: 'get'}),
			transformResponse: (body) => body?.data || [],
			providesTags: ['Subscription'],
		}),
		// Lịch sử cộng/trừ token của chính user. Gắn tag 'Subscription' để tự refetch
		// sau mỗi lượt tốn token (mutation AI invalidate 'Subscription').
		getMyTokenLedger: builder.query({
			query: () => ({url: 'subscription/ledger', method: 'get'}),
			transformResponse: (body) => body?.data || [],
			providesTags: ['Subscription'],
		}),
	}),
});

export const {
	useGetMySubscriptionQuery,
	useGetPlansQuery,
	useGetMyTokenLedgerQuery,
} = subscriptionApiSlice;
